<template>
  <div class="card">
    <div class="card-header">
      <h4 class="card-title">Import Data</h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 p-4">
          <vue-select
            id="selectLimit"
            name="selectLimit"
            class="form-control"
            placeholder="--- Select namespace ---"
            v-model="namespace"
            :options="namespaces"
            close-on-select
            :empty-model-value="null"
          ></vue-select>
        </div>
      </div>
      <div class="row">
        <div class="col-12 p-4">
          <vue-csv-import
            v-model="csv"
            :fields="{
              code: {
                required: true,
                label: 'Code',
              },
              type: {
                required: false,
                label: 'Type',
              },
              year: {
                required: true,
                label: 'Year',
              },
              make: {
                required: true,
                label: 'Make',
              },
              model: {
                required: true,
                label: 'Model',
              },
              modelType: {
                required: true,
                label: 'Model Type',
              },
              description: {
                required: false,
                label: 'Description',
              },
            }"
          >
            <div class="col-12 p-4">
              <vue-csv-toggle-headers></vue-csv-toggle-headers>
            </div>
            <div class="col-12 p-4">
              <vue-csv-errors></vue-csv-errors>
              <vue-csv-input></vue-csv-input>
            </div>
            <div class="col-12 p-4">
              <vue-csv-map></vue-csv-map>
            </div>
          </vue-csv-import>
        </div>
      </div>
      <div class="row">
        <div class="col-12 p-4">
          <div class="progress">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              :aria-valuenow="percentage"
              aria-valuemin="0"
              aria-valuemax="100"
              :style="`width: ${percentage}%`"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row" v-show="showSubmit">
        <div class="col-sm-12 col-md-12 col-xl-12">
          <div role="group" class="float-right btn-group">
            <button @click="submit" class="btn btn-success btn-sm">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div></div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  namespaceList,
  uploadDataChunk,
} from "../../controllers/data-contoller";

export default {
  data: () => {
    return {
      tally: 0,
      namespace: null,
      namespaces: namespaceList,
      csv: [],
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn"]),
    total() {
      return this.csv.length;
    },
    showSubmit() {
      return this.total >= 1 && this.namespace !== null;
    },
    percentage() {
      if (this.csv.length >= 1) {
        return (this.tally / this.csv.length) * 100;
      }
      return 0;
    },
  },
  methods: {
    submit() {
      this.tally = 0;
      this.uploadData(this.csv);
    },
    chunkArray(array, chunkSize) {
      return Array.from(
        { length: Math.ceil(array.length / chunkSize) },
        (_, index) => array.slice(index * chunkSize, (index + 1) * chunkSize)
      );
    },
    async uploadData(dataArray) {
      try {
        const chunks = await this.chunkArray(dataArray, 100);
        for (const chunk of chunks) {
          const processed = await uploadDataChunk(chunk, this.namespace);
          console.log(processed);
          this.tally += processed;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
